module.exports = {"id":"199750","name":"Rilwan Hassan","rating":"71","photo":"./data/images/photos/4/199750.png","club":{"name":"FC Midtjylland","logo":"./data/images/clubs/FCMidtjylland.png"},"positions":["AD","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RilwanHassan0.json
// module id = 3615
// module chunks = 0